<template>
  <div class="pb-[10] bg-[#fff] h-[100vh]">
    <dg-head>
      <div class="flex items-center">
        <p class="cursor-pointer  pr-[40]" @click="push({ path: '/login' })"> <i class="icon">&#xe677;</i> 登录</p>
        <a :href="ENV.official" target="_blank"> <el-button size="mini" type="primary">返回首页</el-button></a>
      </div>
    </dg-head>
    <div class="min-h-[84vh] pt-[84] md:pt-[50] md:min-h-[80vh]">
      <div class="w-[400] mx-[auto]">
        <div id="formData" class="form-box">
          <div class="t-[24] text-center pt-[40] pb-[16] t-[#303133] font-500">
            设置新密码</div>
          <div class="pb-[5]" v-if="tips.msg">
            <el-alert @close="() => { tips.msg = ''; tips.type = 'error'; }" v-show="tips.msg" :title="tips.msg"
              :type="tips.type" show-icon>
            </el-alert>
          </div>
          <el-form :model="formData" ref="formDataRef" label-width="1px">
            <div class="relative">
              <el-form-item label="" prop="confirmPassword" :rules="rules.password" class="relative mb-[20]">
                <el-input size="large" class="large_input" @input="changeConfirmPassword"
                  @focus="intensityVisible = true" @blur="intensityVisible = false" show-password placeholder="请输入新密码"
                  v-model="formData.confirmPassword">
                </el-input>
              </el-form-item>

              <dg-pasw-intensity v-show="intensityVisible" :value="formData.confirmPassword"></dg-pasw-intensity>
            </div>
            <div class="relative">
              <el-form-item label="" prop="newPassword" :rules="rules.confirmPassword" class="relative mb-[20]">
                <el-input class="large_input" size="large" @focus="intensityVisible1 = true"
                  @blur="intensityVisible1 = false" show-password placeholder="再次确认密码" v-model="formData.newPassword"
                  @input="change"> </el-input>
              </el-form-item>

              <dg-pasw-intensity v-show="intensityVisible1" :value="formData.newPassword"></dg-pasw-intensity>

            </div>
            <div class="pt-[16]">
              <el-button class="w-[100%]" type="primary" @click="handlerVerification('formDataRef')">下一步</el-button>
            </div>
          </el-form>
        </div>

      </div>
    </div>
    <dg-copyright></dg-copyright>
  </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import { encryptDES } from "@/assets/js/utils";
let newPassword = '';
let confirmPassword_value = '';
export default {
  mixins: [mixin],
  data() {
    var password = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('密码格式错误，请重新输入'));
      } else if (!(/^(?!.*(.)\1{2,})(?=.*[a-zA-Z].*[0-9]|[a-zA-Z].*[!@#$%^&*()_+[\]{};':"\\|,.<>?`~]|[0-9].*[!@#$%^&*()_+[\]{};':"\\|,.<>?`~]).{6,32}$/).test(value)) {
        callback(new Error('密码格式错误，请重新输入'));
      } else {
        callback();
      }
    }
    var confirmPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('密码格式错误，请重新输入'));
      } else if (!(/^(?!.*(.)\1{2,})(?=.*[a-zA-Z].*[0-9]|[a-zA-Z].*[!@#$%^&*()_+[\]{};':"\\|,.<>?`~]|[0-9].*[!@#$%^&*()_+[\]{};':"\\|,.<>?`~]).{6,32}$/).test(value)) {
        callback(new Error('密码格式错误，请重新输入'));
      } else if (confirmPassword_value !== newPassword) {
        callback(new Error('两次密码不一致，请重新输入'));
      } else {
        callback();
      }
    }
    return {
      alertShow: false,
      alertMsg: "",
      alertType: 'error',
      verificationCode: "",
      intensityVisible: false,
      intensityVisible1: false,
      rules: {
        password: [
          { required: true, validator: password }
        ],
        confirmPassword: [
          { required: true, validator: confirmPassword }
        ],
      },
      formData: {
        // http://api.jfyancheng.com:8080/doc.html#/default/%E5%AE%98%E7%BD%91%E5%89%8D%E5%8F%B0-%E8%AE%A4%E8%AF%81%E6%A8%A1%E5%9D%97/changePasswordUsingPOST
        confirmPassword: "",  // 再次确认密码 
        mobile: sessionStorage.getItem('modifyPaswLast_phone'),  // 手机号 
        newPassword: "",  // 密码，cookie值加上当前日期做密钥（JSESSIONID-yyyy-MM-dd），对明文进行des加密 
      },
      tips: {
        msg: '',
        type: 'error'
      },
    };
  },
  methods: {
    /**
     * @author 伟健 / 张
     * @name 登录
     */
    async handlerVerification(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          ajax.post({
            url: "/customer/auth/changePassword",
            data: {
              confirmPassword: encryptDES(this.formData.confirmPassword),  // 再次确认密码 
              mobile: sessionStorage.getItem('modifyPaswLast_phone'),  // 手机号 
              newPassword: encryptDES(this.formData.newPassword),  // 密码，cookie值加上当前日期做密钥（JSESSIONID-yyyy-MM-dd），对明文进行des加密 
            },
            self: this,
            success: res => {
              if (res) {
                // this.$message.success("密码修改成功，请重新登录");

                this.$router.replace({ path: '/login' });
              }
            },
            fail: (err) => {
              this.tips.msg = err.msg;
              this.tips.type = 'error';
            }
          });
        }
      });
    },
    change() {
      newPassword = this.formData.newPassword
    },
    changeConfirmPassword() {
      confirmPassword_value = this.formData.confirmPassword
    }

  },
  mounted() {

  },
  created() {
  }
};
</script>

<style scoped lang="less">
// @import '~@/assets/css/var.less';
.shadow {
  box-shadow: 0 2px 10px 0 rgba(45, 72, 97, .1);
}
</style>
